import { FolderCoursesItems } from "./FolderCoursesItems";
import { FolderExamsItems } from "./FolderExamsItems";
import { FolderFlashcardsItems } from "./FolderFlashcardsItems";
import { FolderNotesItems } from "./FolderNotesItems";
import { FolderItemType, SelectedItem } from "./types";

interface FolderPaginatedItemsProps {
	folderId: string;
	type: FolderItemType;
	searchValue?: string;
	isSelectMode: boolean;
	selectedItems: SelectedItem[];
	toggleSelection: (item: Record<string, any>, itemType: FolderItemType, folderItemId: string) => void;
}

export const FolderPaginatedItems = ({
	folderId,
	type,
	searchValue,
	isSelectMode,
	selectedItems,
	toggleSelection,
}: FolderPaginatedItemsProps) => {
	const validTypes: FolderItemType[] = ["deck", "exam", "course", "note"];
	const isValidType = validTypes.includes(type);

	if (!isValidType || !folderId) {
		return null;
	}

	const selectionProps = { isSelectMode, selectedItems, toggleSelection };

	switch (type) {
		case "exam":
			return (
				<FolderExamsItems
					folderId={folderId}
					searchValue={searchValue}
					{...selectionProps}
				/>
			);
		case "course":
			return (
				<FolderCoursesItems
					folderId={folderId}
					searchValue={searchValue}
					{...selectionProps}
				/>
			);
		case "deck":
			return (
				<FolderFlashcardsItems
					folderId={folderId}
					searchValue={searchValue}
					{...selectionProps}
				/>
			);
		case "note":
			return (
				<FolderNotesItems
					folderId={folderId}
					searchValue={searchValue}
					{...selectionProps}
				/>
			);
		default:
			return null;
	}
};
